import { NgModule } from '@angular/core';
import { FirebaseApp } from '@angular/fire/app';
import { getDatabase, provideDatabase } from '@angular/fire/database';
import { FirebaseWrapper } from './services';

@NgModule({
  imports: [provideDatabase((injector) => getDatabase(injector.get(FirebaseApp)))],
  providers: [FirebaseWrapper]
})
export class RealtimeDbModule {}
